var property = require('../util').property;

function Paginator(name, paginator) {
  property(this, 'inputToken', paginator.input_token);
  property(this, 'limitKey', paginator.limit_key);
  property(this, 'moreResults', paginator.more_results);
  property(this, 'outputToken', paginator.output_token);
  property(this, 'resultKey', paginator.result_key);
}

module.exports = Paginator;



/*****************
 ** WEBPACK FOOTER
 ** ./~/aws-sdk/lib/model/paginator.js
 ** module id = 305
 ** module chunks = 0
 **/